/**
 * Store setting that can be copied from one store to another from the
 * Copy Settings page. Add a key here, a label below, and a branch in the
 * `copyStoreSettings$` effect to support copying another setting.
 */
export type TCopyableStoreSetting = 'priceBanding' | 'generalFilters' | 'stockTakeFilters';

/**
 * Display labels for the copyable settings multi-select and result modals.
 */
export const COPYABLE_STORE_SETTING_LABELS: Record<TCopyableStoreSetting, string> = {
  priceBanding: 'Price Banding',
  generalFilters: 'General Filters',
  stockTakeFilters: 'Stock Take Filters',
};

/**
 * Every setting the Copy Settings page offers, in display order.
 */
export const COPYABLE_STORE_SETTINGS: TCopyableStoreSetting[] = [
  'priceBanding',
  'generalFilters',
  'stockTakeFilters',
];

/**
 * Outcome of a copy run, held in the settings store so the page can show a
 * result modal without listening to the action stream.
 */
export interface ICopyStoreSettingsResult {
  settings: TCopyableStoreSetting[];
  succeeded: boolean;
  targetStoreName: string;
}
